import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { history } from '../../../../helpers';
import { cohortActions } from '../../../../store';

import type { AddCohortFormValues } from '../constants/types/general';

export default function useAddCohortFormSubmit() {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();

  const submitAddCohortForm = useCallback(
    async (values: AddCohortFormValues) => {
      const { error } = await dispatch(
        cohortActions.createCohort({
          data: values,
          getAccessTokenSilently,
        }),
      );
      if (!error) {
        dispatch(cohortActions.getList({ getAccessTokenSilently }));
        history.navigate('/admin');
      }
    },
    [dispatch, getAccessTokenSilently],
  );

  return { submitAddCohortForm };
}
